export default function Double_Click_to_Fill() {
  return (
    <div className="p-4">
      <h1>Double Click to Fill</h1>
    </div>
  );
}
